import type { PropType, ExtractPropTypes } from 'vue'
import { definePropType } from '../../../utils/vue-utils'
import type { TableData, TableColumnData } from './types'

export const tableProps = {
  data: {
    type: definePropType<TableData[]>(Array),
    default: () => []
  },
  columns: {
    type: definePropType<TableColumnData[]>(Array),
    default: () => []
  },
  border: {
    type: Boolean,
    default: false
  },
  hover: {
    type: Boolean,
    default: false
  },
  stripe: {
    type: Boolean,
    default: false
  },
  selection: {
    type: definePropType<TableData[]>(Array),
    default: undefined
  },
  selectedKeys: {
    type: definePropType<(string | number)[]>(Array)
  },
  // 是否可以拖拽改变column的宽度
  columnResizable: {
    type: Boolean,
    default: true
  },
  // 表格固定高度。固定表头
  height: {
    type: [String, Number],
    default: undefined
  },
  maxHeight: {
    type: [String, Number],
    default: undefined
  },
  defaultSort: {
    type: Object as PropType<{
      sort?: 'ascend' | 'descend' | ''
      prop?: string | number
      popup?: boolean
    }>,
    default: () => ({
      sort: '',
      prop: '',
      popup: false
    })
  },
  config: {
    type: Object as PropType<{ setting: boolean }>,
    default: () => ({
      setting: false
    })
  },
  rowHeight: {
    type: [String, Number] as PropType<string | number>,
    default: 68
  },
  loading: {
    type: Boolean,
    default: false
  },
  // 默认空值填充
  defaultEmptyFill: {
    type: String,
    default: ''
  },
  // 主键名，Tr唯一索引使用
  primaryKey: {
    type: String,
    default: undefined
  },
  // 表格行key的取值字段，此key区分行的唯一性包括选中的行、排序、过滤等
  rowKey: {
    type: String,
    default: 'key'
  }
}

export type TableProps = ExtractPropTypes<typeof tableProps>
